import React, { useState, useEffect, useMemo, memo } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import {
  InputGroup,
  Button,
  FormControl,
  Col,
  Accordion,
  Row,
  Card,
  Spinner,
} from "react-bootstrap";
import _ from "lodash";
import ApiPublicPromoCodeService from "../../../../core/api/api.publicPromoCode";

import { FormProvider, useForm, Controller } from "react-hook-form";

import { useLocation, Link } from "react-router-dom";
import DataGridPromoCode from "./DataGridPromoCode";
import { NewPublicPromoCodeModal } from "./NewPublicPromoCodeModal";
import { QrPromoCodeModal } from "../QrCode/QrPromoCodeModal";

const Index = () => {
  let location = useLocation();

  const [listData, setListData] = useState({});
  const [checkBoxList2, setCheckBoxList2] = useState([]);
  //const [checkBoxList, setcheckBoxList] = useState({});
  const [showModalPromoCode, setShowModalPromoCode] = useState(false);
  const [showModalQrPromoCode, setShowModalQrPromoCode] = useState(false);
  const [selectedPromoCodeId, setSelectedPromoCodeId] = useState(null);
  const [selectedQrCode, setSelectedQrCode] = useState(null);

  const [refresh, setRefresh] = useState(false);
  const [callBackPublicPromoCode, setcallBackPublicPromoCode] = useState(null);
  const [formInputspromoCategory, setFormInputspromoCategory] = useState({
    value: -1,
    label: "انتخاب",
  });

  const [promoCode, setpromoCode] = useState([]);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors },
    getValues,
    setValue,
    watch,
  };
  useEffect(() => {
    (async () => {
      try {
        const data = await ApiPublicPromoCodeService.getAll({
          pageSize: getValues("pageSize"),
          pageNumber: getValues("pageNumber"),
        });

        setListData(data);
        setValue("totalCount", data.totalCount);
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();

    return () => {};
  }, [refresh]);
  const callBackJustForRunUseEffect = (promoCode) => {
    setRefresh(!refresh);
    setcallBackPublicPromoCode(promoCode);
  };

  const onSubmit = async (data) => {
    // console.log(data);

    const apiData = await ApiPublicPromoCodeService.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: data.globalSearch,
    });
    setListData(apiData);
  };

  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };
  const inputChangeHandlerPromoCategory = (event) => {
    setValue("promoCategoryId", { value: event.value, label: event.label });
  };
  const inputChangeHandlerAgent = (event) => {
    setValue("agentId", { value: event.value, label: event.label });
  };
  const inputChangeHandlerPromoCategoryCommision = (event) => {
    setValue("promoCategoryCommisionId", {
      value: event.value,
      label: event.label,
    });
  };
  return (
    <div>
      {console.log(location)}
      {!_.isEmpty(location.state) && location.state?.neWPublicPromoCode ? (
        <NewPublicPromoCodeModal callback={callBackJustForRunUseEffect} />
      ) : location?.state?.neWPublicPromoCode?.promoCodeId > 0 ? (
        <NewPublicPromoCodeModal
          callback={callBackJustForRunUseEffect(promoCode)}
        />
      ) : location.state?.neWQrCodePromoCode ||
        callBackPublicPromoCode != null ? (
        <QrPromoCodeModal
          callback={callBackJustForRunUseEffect}
          promoCodeProp={callBackPublicPromoCode}
        ></QrPromoCodeModal>
      ) : (
        <></>
      )}
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              کد تخفیف عمومی مشتریان
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست کدهای تخفیف عمومی تخصیص یافته
            </span>
          </h3>
          <div className="card-toolbar">
            {/* <Link variant="success" className="btn btn-success"
                            key={0}
                            to={{
                                pathname: "/publicPromoCode/0",
                                state: { neWPublicPromoCode: true }
                            }}
                        >
                            <AddCircle className='mr-1' />
                                ایجاد کد تخفیف عمومی جدید
                             </Link> */}
            <Button
              className="btn btn-primary"
              onClick={() => {
                setSelectedPromoCodeId(0);
                setShowModalPromoCode(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد کد تخفیف عمومی جدید
            </Button>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="border-top pt-3">
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <FormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridPromoCode
                    data={listData}
                    setCheckBoxList2={setCheckBoxList2}
                    callBack={callBackJustForRunUseEffect}
                    setShowModalPromoCode={setShowModalPromoCode}
                    setSelectedPromoCodeId={setSelectedPromoCodeId}
                    setShowModalQrPromoCode={setShowModalQrPromoCode}
                    setSelectedQrCode={setSelectedQrCode}
                  />
                }
              </Col>
              {showModalPromoCode && (
                <NewPublicPromoCodeModal
                  showModalPromoCode={showModalPromoCode}
                  setShowModalPromoCode={setShowModalPromoCode}
                  selectedPromoCodeId={selectedPromoCodeId}
                />
              )}
              {showModalQrPromoCode && (
                <QrPromoCodeModal
                  showModalQrPromoCode={showModalQrPromoCode}
                  setShowModalQrPromoCode={setShowModalQrPromoCode}
                  selectedQrCode={selectedQrCode}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Index;
